<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Зонирование</strong>
                    </CCardHeader>
                    <AppTabLinks :links="tabLinks" class="mx-4 mt-2" />
                    <CCardBody>
                        <div class="table__preloader" v-if="loading">
                            <CSpinner color="primary"/>
                        </div>
                        <template v-else>
                            <template v-for="(item, zoneIndex) in zones">
                                <div :key="item.id" class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                                    <CRow>
                                        <CCol
                                            tag="label"
                                            sm="3"
                                            class="col-form-label">Название</CCol>
                                        <CCol sm="7">
                                            <CInput v-model="item.name" label="" />
                                        </CCol>
                                        <CCol sm="2" class="flex-end">
                                            <CButton
                                                color="danger"
                                                @click="removeZone(zoneIndex)"
                                            ><CIcon
                                                :content="$options.icons.cilTrash"
                                            /></CButton>
                                        </CCol>
                                        <CCol sm="12">
                                            <CRow :key="item.id" class="mx-0">
                                                <template v-for="(tower, towerIndex) in item.towers">
                                                    <CCol :key="`address-${towerIndex}-${tower.id}`" sm="4">
                                                        <div class="tower-line tower-border col-form-label">
                                                            <span>{{tower.name}}</span>
                                                            <CButton
                                                                color="danger"
                                                                @click="removeTower(zoneIndex, towerIndex)"
                                                            >X</CButton>
                                                        </div>
                                                    </CCol>
                                                </template>
                                            </CRow>
                                            <div class="flex-end pt-1">
                                                <CButton
                                                    color="primary"
                                                    @click="showAddresses(zoneIndex)"
                                                >Добавить башни</CButton>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </div>
                            </template>
                        </template>
                    </CCardBody>

                    <CCardFooter>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="save"
                        >Сохранить</CButton>
                        <CButton
                            color="primary"
                            class="mr-3"
                            @click="addZone"
                        >Добавить зону</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CModal 
            :show.sync="addressesModal"
            @click="activeZoneId = null"
        >
            <div v-if="!filteredTowers.length">
                Все башни разпределены по зонам
            </div>
            <template v-for="tower in filteredTowers">
                <div class="tower-line py-1" :key="`address-${tower.id}`">
                    <span>{{tower.name}}</span>
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="addTower(tower)">Добавить</CButton>
                </div>
            </template>
            <div slot="footer"></div>
        </CModal>
    </div>
</template>

<script>
    import { cilTrash } from '@coreui/icons';
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        name: 'DemandsList',

        components: {
            AppTabLinks,
        },

        icons: {
            cilTrash
        },

        data() {
            return {
                tabLinks: [
                    {
                        title: 'Зоны',
                        url: `/delivery-zones`,
                    },
                    {
                        title: 'Тарифы',
                        url: `/delivery-zones/params`,
                    },
                ],
                loading: true,
                zones: [],
                deletedZoneIds: [],
                towers: [],
                activeZoneIndex: null,
                addressesModal: false
            };
        },

        computed: {
            filteredTowers() {
                return this.towers.filter(item => !item.delivery_zone_id);
            }
        },

        async created() {
            await Promise.all([this.fetchZones(), this.fetchTowers()]);
            this.loading = false;
        },

        methods: {
            async fetchZones() {
                const response = await this.axios.get('/delivery-zones');
                this.zones = response.data;
            },
            async fetchTowers() {
                const response = await this.axios.get('/address');
                this.towers = response.data;
            },
            addZone() {
                this.zones.push({
                    tmp_id: `tmp-${this.zones.length + 1}`,
                    name: '',
                    towers: []
                });
            },
            removeZone(zoneIndex) {
                for(const tower of this.zones[zoneIndex].towers) {
                    for(const item of this.towers) {
                        if(tower.id === item.id) {
                            item.delivery_zone_id = null;
                        }
                    }
                }
                if(this.zones[zoneIndex].id) {
                    this.deletedZoneIds.push(this.zones[zoneIndex].id);
                }
                this.zones.splice(zoneIndex, 1);
            },
            showAddresses(index) {
                this.activeZoneIndex = index;
                this.addressesModal = true;
            },
            addTower(tower) {
                this.zones[this.activeZoneIndex].towers.push(tower);
                for(const item of this.towers) {
                    if(item.id === tower.id) {
                        item.delivery_zone_id = this.zones[this.activeZoneIndex].id || this.zones[this.activeZoneIndex].tmp_id;
                    }
                }
            },
            removeTower(zoneIndex, towerIndex) {
                for(const item of this.towers) {
                    if(item.id === this.zones[zoneIndex].towers[towerIndex].id) {
                        item.delivery_zone_id = null;
                    }
                }
                this.zones[zoneIndex].towers.splice(towerIndex, 1);
            },
            async save() {
                this.loading = true;

                for(const id of this.deletedZoneIds) {
                    await this.axios.delete(`/delivery-zones/${id}`);
                }

                for(const zone of this.zones) {
                    if(!zone.name) {
                        this.$root.$emit('showError', 'У каждой зоны должно быть название');
                        return;
                    }
                }

                for(const zone of this.zones) {
                    if(zone.id) {
                        await this.axios.put(`/delivery-zones/${zone.id}`, zone);
                    } else {
                        const newZone = (await this.axios.post(`/delivery-zones`, zone)).data;
                        zone.id = newZone.id;
                        for(const tower of zone.towers) {
                            tower.delivery_zone_id = newZone.id;
                        }
                        await this.axios.put(`/delivery-zones/${zone.id}`, zone);
                    }
                }

                for(const tower of this.towers) {
                    if(!tower.delivery_zone_id) {
                        await this.axios.put(`/address/${tower.id}`, tower);
                    }
                }

                await this.fetchZones();
                this.loading = false;
                this.$root.$emit('showAlert', 'Изменения успешно сохранены');
            }
        },
    };
</script>

<style>
    .flex-end {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
    }
    .tower-line {
        display: flex; 
        justify-content: space-between; 
        align-items: center;
    }
    .tower-border {
        margin: 3px -11px;
        padding: 5px 5px 5px 10px;
        border: 1px solid #d8dbe0;
        border-radius: 0.25rem;
    }
</style>